import { useState } from 'react';
import { today, daysAgo } from '../components/DateBar';
import DateBar from '../components/DateBar';
import TransactionsTable from '../components/TransactionsTable';

export default function TransactionsPage() {
  const [preset, setPreset] = useState(1);
  const [start,  setStart]  = useState(daysAgo(6));
  const [end,    setEnd]    = useState(today);

  return (
    <div className="page-body">
      <div className="page-title">Transactions</div>
      <div className="page-subtitle">Full paginated bill-by-bill transaction records</div>
      <DateBar start={start} end={end} preset={preset} setStart={setStart} setEnd={setEnd} setPreset={setPreset} loading={false} />
      <TransactionsTable start={start} end={end} />
    </div>
  );
}
